import { Button } from "@/components/ui/button";

const VisitorStatsDisplay = ({ stats }) => (
  <div className="flex items-center gap-2 bg-slate-800 rounded-lg px-2 py-1 text-xs">
    <div className="text-center">
      <span className="block text-blue-400 font-bold">{stats.today}</span>
      <span className="text-slate-500 text-[10px]">Today</span>
    </div>
    <div className="w-px h-5 bg-slate-700" />
    <div className="text-center">
      <span className="block text-green-400 font-bold">{stats.week}</span>
      <span className="text-slate-500 text-[10px]">Week</span>
    </div>
    <div className="w-px h-5 bg-slate-700" />
    <div className="text-center">
      <span className="block text-purple-400 font-bold">{stats.total}</span>
      <span className="text-slate-500 text-[10px]">Total</span>
    </div>
  </div>
);

const SiteHeader = ({ user, visitorStats, onLoginClick, onLogout }) => (
  <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-slate-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex justify-between items-center">
      <h1 className="text-lg sm:text-2xl font-bold text-white tracking-tight">Uncovering The Hidden UK</h1>
      <nav className="flex items-center gap-2 sm:gap-4">
        <a
          href="mailto:ukdiscovered@gmail.com"
          className="text-slate-400 hover:text-white text-sm flex items-center gap-1.5 transition-colors"
          title="Contact us"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span className="hidden md:inline">ukdiscovered@gmail.com</span>
        </a>
        {user ? (
          <div className="flex items-center gap-2 sm:gap-4">
            <VisitorStatsDisplay stats={visitorStats} />
            <span data-testid="logged-in-user" className="hidden md:inline text-slate-300 text-sm">
              <span className="text-blue-400 font-medium">{user.username}</span>
            </span>
            <Button
              data-testid="logout-button"
              onClick={onLogout}
              variant="outline"
              size="sm"
              className="border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white"
            >
              Logout
            </Button>
          </div>
        ) : (
          <Button
            data-testid="admin-button"
            onClick={onLoginClick}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6"
          >
            Admin
          </Button>
        )}
      </nav>
    </div>
  </header>
);

export default SiteHeader;
